import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  storage: Storage;
  constructor() {
    this.storage = window.localStorage;
  }

  /**
   *
   *
   * @name setItem
   * @description Function to store data in local storage
   * @template T
   * @param key
   * @param value
   * @memberof LocalStorageService
   */
  setItem<T>(key: string, value: T): void {
    this.storage.setItem(key, JSON.stringify(value));
  }

  /**
   *
   *
   * @name getItem
   * @description Function to retrieve data from local storage
   * @template T
   * @param key
   * @returns
   * @memberof LocalStorageService
   */
  getItem<T>(key: string): T {
    return JSON.parse(this.storage.getItem(key));
  }

  /**
   *
   *
   * @name removeItem
   * @description Function to remove data from local storage
   * @param key
   * @memberof LocalStorageService
   */
  removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  /**
   * @name clear
   * @description Function to clear all data from local storage
   * @memberof LocalStorageService
   */
  clear(): void {
    this.storage.clear();
  }
}
